import { render, staticRenderFns } from "./vehicleModal.vue?vue&type=template&id=54e6d617&"
import script from "./vehicleModal.vue?vue&type=script&lang=js&"
export * from "./vehicleModal.vue?vue&type=script&lang=js&"
import style0 from "./vehicleModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports